<div class="main-page">
    <div class="container">
        <ngx-spinner></ngx-spinner>
        <div class="plans-area">
            <div class="innerPage plans-area-inner">
                <div class="row mb-4">
                    <div class="col-md-12 d-flex justify-content-center align-items-center">
                        <span class="d-block text-white font-weight-bold h4 heading">Explore Business Resources</span>
                    </div>
                </div>
                <div *ngIf="user.subscriptionPlanType !== '6483145a522e756b4497aa13'">
                    <div class="my-lg-5" *ngIf="allResources.length<=0">
                        <img class="no-data-icon" src="../../assets/no-data.png" alt="">
                        <br>
                        <span class="text-white font-weight-bold">
                            No Record Found
                        </span>
                    </div>
                    <div *ngFor="let resources of allResources"
                        class="row  mt-2 d-flex justify-content-between align-items-center card-outer py-2">
                        <div class="col-md-12 col-lg-12 col-sm-12">
                            <div class="post-body" (click)="goToLink(resources?.url)">
                                {{resources?.url}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="my-lg-5" *ngIf="user.subscriptionPlanType == '6483145a522e756b4497aa13'">
                    <img class="no-data-icon" src="../../assets/no-data.png" alt="">
                    <br>
                    <span class="text-white font-weight-bold mt-2">
                        Purchase Plan to access it
                    </span>
                </div>
            </div>
        </div>
    </div>